import { ButtonHTMLAttributes, forwardRef } from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';
import { IButtonAnalyticsProps } from './types';
import { AnalyticsHtmlButton } from './AnalyticButton';

type IProps = ButtonHTMLAttributes<HTMLButtonElement> & IButtonAnalyticsProps;

const StyledControlButton = styled(AnalyticsHtmlButton)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border-top: 1px solid ${theme.colors.mainBlue};
  border-right: 1px solid ${theme.colors.mainBlue};
  border-bottom: 1px solid ${theme.colors.mainBlue};
  cursor: pointer;
  user-select: none;
  font: inherit;
  color: ${theme.colors.mainBlue};

  &:disabled {
    color: ${theme.colors.secondary400};
  }

  &:first-child {
    border-left: 1px solid ${theme.colors.mainBlue};
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  &:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`;

const ControlButton = forwardRef<HTMLButtonElement, IProps>(
  ({ children, type, ...props }, ref) => (
    <StyledControlButton ref={ref} type={type || 'button'} {...props}>
      {children}
    </StyledControlButton>
  ),
);

export default ControlButton;
